import { ProductTier } from '@sparemin/api-sdk';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { SubscriptionPeriod } from 'blocks/Pricing/types';
import Button from 'components/Button';
import PlanAction from '../PlanAction';
import { planCTALabelSelector } from '../selectors';
import { basicPlanBlock as block } from '../utils';

export interface BasicPlanCtaProps {
  period: SubscriptionPeriod;
  ctaOverride?: React.ReactNode;
  onClick?: () => void;
}

const BasicPlanCta: React.FC<BasicPlanCtaProps> = ({
  period,
  ctaOverride,
  onClick,
}) => {
  const label = useSelector(state =>
    planCTALabelSelector(state, {
      tier: ProductTier.BASIC,
      subscriptionPeriod: period,
    }),
  );

  return (
    <PlanAction className={block('cta')} onClick={onClick}>
      {ctaOverride ?? (
        <Button>
          <span className={block('cta-text')}>{label}</span>
        </Button>
      )}
    </PlanAction>
  );
};

export default BasicPlanCta;
